import React from 'react';
import { connect } from 'react-redux';
import util from 'Utils/commonUtil';

// Components
import Header from 'Components/common/Header';
import Anchor from 'Components/common/Anchor';
import SearchInput from 'Components/common/SearchInput';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import InternalTransferOrderItem from './InternalTransferOrderItem';
import BasicButton from 'Components/common/BasicButton';

// Actions
import {
    updateF1OrderSearchFields, 
    updateF1OrderSearchList, 
    updateF1OrderReceiveSearchList,
    updateF1OrderDetails,
    getInternalOrderList,
    updateInternalTransferSearchList
} from 'Actions/host';
import { T } from 'Actions/translate';

class InternalTransferOrderList extends React.Component {
    pager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999
    }

    state = {
        searchValue: '',
        tabList: [
            { index: 0, text: T('host_internal_callout_order'), tabFlag: 'OUT' },
            { index: 1, text: T('host_internal_callin_order'), tabFlag: 'IN' }
        ],
        tabActive: 0,
        listLoaded: true
    }

    componentWillMount() {
        window.scrollTo(0,0);
        let tab = this.props.history.location.state && this.props.history.location.state.orderType
        if(this.props.history.location.state && this.props.history.location.state=='user'){
            this.props.updateInternalTransferSearchList({
                queryKey: { $set: '' }
            });
            this.setState({
                searchValue:"",
                tabActive:tab || 0
            },()=>{
                this.getList()
            })
        }else{
            this.props.updateInternalTransferSearchList({
                queryKey: { $set: this.props.queryKey }
            });
            this.setState({
                searchValue:this.props.queryKey,
                tabActive:tab || 0
            },()=>{
                this.getList()
            })
        }
        this.props.updateF1OrderSearchList([]);
    }

    //tabs change
    handleChangeTab(item) {
        this.setState({ tabActive: item.index }, () => {
            this.pager.page = 0;
            this.pager.total = 0;
            this.pager.pageTotal = 9999999999999999999999999;

            this.getList();
        });
    }

    getList = () => {
        const { tabList, tabActive,searchValue } = this.state;

        if(this.pager.page >= this.pager.pageTotal) return;

        this.setState({ listLoaded: false });

       this.props.getInternalOrderList({
            pageNum: this.pager.page + 1,
			pageSize: this.pager.length,
            inOrOut: tabList[tabActive].tabFlag,
            key: (this.props.history.location.state && this.props.history.location.state=='user' ) ? searchValue:this.props.queryKey.trim()
        }).then(res => {
            this.pager.page = res.pageNum;
            this.pager.total = res.total;
            this.pager.pageTotal = res.pageTotal;
            this.setState({ listLoaded: true });
        });
    }

    chooseItem = item => {
        const { tabActive } =this.state
        if(tabActive==0){
            switch(item.status) {
                case 'DRAFT':
                    this.props.history.push(`/addTransferOrder?orderId=${item.id}`,{orderType: this.state.tabActive});
                    break;
                default:
                    this.props.history.push(`/internalTransferOrderDetail/${ item.id }`, {id: item.id, orderType: this.state.tabActive});
            }
        }else{
            this.props.history.push(`/internalTransferOrderDetail/${ item.id }`, {id: item.id, orderType: this.state.tabActive});
        }
    }

    goBack = () => this.props.history.push('/userCenter');

    addTransferOrder = () => {
        this.props.history.push('/addTransferOrder');
    }

    refreshList =()=>{
        const { tabList, tabActive } = this.state;
        this.setState({ listLoaded: false });

        this.props.getInternalOrderList({
            pageNum: 1,
			pageSize: this.pager.length,
            inOrOut:  tabList[tabActive].tabFlag,
            key: this.props.queryKey.trim()
        }).then(res => {
            this.pager.page = res.pageNum;
            this.pager.total = res.total;
            this.pager.pageTotal = res.pageTotal;
            this.setState({ listLoaded: true });
        });
    }

    submitSuccess = ()=>{
       this.refreshList()
    }

    //顶部搜索框
    changeSearchInput = (title, value)=>{
        this.props.updateInternalTransferSearchList({
            [title]: { $set: value }
        });

        this.setState({
            searchValue:value
        })
    }

    search = ()=>{
        this.refreshList()
    }

    render() {
        const { tabList, tabActive, listLoaded,searchValue } = this.state;
        const { internalOrderList,localData } = this.props;

        return(
            <div className="internal-transfer-order-list-container" data-testid="scc-internal-transfer-page">
                <Header hasUserCenter={ true } hasArrowBackIos={ true } backEvent={this.goBack}>
                    <div className="F1-order-list-header">
                        <h3 className="header-title">{T('internal_transfer_order')}</h3>
                        <SearchInput title="queryKey" value={ searchValue }  
                            // options={{ hideSearchBtn: true }} 
                            onChange={this.changeSearchInput}
                            search={ this.search }
                            placeholder={ T('enter_orderNo_sku_supply_center') }
                            testid="scc-internal-transfer-search-input">
                        </SearchInput>
                    </div>
                    <div className="tab-header">
                        {
                            tabList.map((item, index) => {
                                return (
                                    <Anchor key={ item.index } testid={item.tabFlag === 'OUT' ? 'scc-internal-transfer-outbound-tab' : 'scc-internal-transfer-inbound-tab'} className={ util.getClassName({ 'tab-item': true, active: index === tabActive }) } onClickOfSingleTap={ () => { this.handleChangeTab(item) } }>{ item.text }</Anchor>
                                );
                            })
                        }
                    </div>
                </Header>
                <ScrollWrapper listLoaded={ listLoaded } showAbyss={ this.pager.page >= this.pager.pageTotal } showLoadingMore={ !listLoaded } getMoreData={()=>{this.getList()}}>
                    <ul className="internal-transfer-order-list">
                        {            
                            internalOrderList[tabList[tabActive].tabFlag] && internalOrderList[tabList[tabActive].tabFlag].length > 0 ? internalOrderList[tabList[tabActive].tabFlag].map((item, index) => (
                                <li key={ index } className="internal-transfer-item" data-testid="scc-internal-transfer-order-card" data-order-number={item.orderNumber}>
                                    <InternalTransferOrderItem 
                                    item={ item } 
                                    tabActive={tabActive} 
                                    chooseItem={ () => this.chooseItem(item) }
                                    submitSuccess={this.submitSuccess}
                                    />
                                </li>
                            )):  null
                        }
                    </ul>
                    {
                      localData.roleType === 1 || localData.roleType === 2 ? 
                        <div className="internal-order-list-footer">
                            <BasicButton
                                type="primary"
                                className="new-transfer-btn"
                                testid="scc-internal-transfer-create-button"
                                onClickOfSingleTap={this.addTransferOrder}
                                isStopPropagation={true}>
                                {T('host_internal_order_new_transfer')}
                            </BasicButton>
                      </div> :null 
                    }
                    
                </ScrollWrapper>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { host,localData } = state;
	return {
        localData,
        internalOrderList: host.internalOrderList,
        queryKey: host.internalTransferSearchfields.queryKey,
	};
};

const mapDispatchToProps = {
    updateF1OrderSearchFields,
    updateF1OrderSearchList,
    updateF1OrderReceiveSearchList,
    updateF1OrderDetails,
    getInternalOrderList,
    updateInternalTransferSearchList
};

export default connect(mapStateToProps, mapDispatchToProps)(InternalTransferOrderList);
